<template>
  <div>
    <v-container fluid class="pb-0" v-show="!loading">
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Cadastro de Remessa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-3"
            @click="$router.push('/remessas')"
            :disabled="salvando"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-5"
            class="ml-2"
            :disabled="!form_valid"
            :loading="salvando"
            @click="salvar"
            >Salvar</v-btn
          >
        </v-app-bar>
        <v-form ref="form" lazy-validation v-model="form_valid">
          <v-container fluid>
            <v-row v-show="loading">
              <v-col
                class="ma-6 pa-6"
                style="display: flex; align-items: center; justify-content: center; text-align: center"
              >
                <v-progress-circular
                  size="64"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row dense v-show="!loading">
              <v-col cols="12" sm="2">
                <v-text-field
                  ref="numero"
                  label="Número"
                  v-model="remessa.numero"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="7">
                <v-text-field
                  ref="motorista"
                  label="Motorista"
                  :rules="rulesForm.motorista"
                  v-model="remessa.motorista"
                  @keydown.native.enter="$refs.placa.focus()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  ref="placa"
                  label="Placa"
                  :rules="rulesForm.placa"
                  v-model="remessa.placa"
                  v-mask="'AAA-#X##'"
                  @input="(value) => (remessa.placa = value.toUpperCase())"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="3">
                <as-date-picker-menu
                  ref="data_saida"
                  label="Data Saída"
                  :rules="rulesForm.data_saida"
                  v-model="remessa.data_saida"
                  :min="hoje"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <as-time-picker
                  ref="hora_saida"
                  label="Hora Saída"
                  :rules="rulesForm.hora_saida"
                  v-model="remessa.hora_saida"
                ></as-time-picker>
              </v-col>
              <v-col cols="12" sm="3">
                <as-date-picker-menu
                  ref="data_chegada"
                  label="Data Chegada"
                  :rules="rulesForm.data_chegada"
                  v-model="remessa.data_chegada"
                  :min="hoje"
                ></as-date-picker-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <as-time-picker
                  ref="hora_chegada"
                  label="Hora Chegada"
                  :rules="rulesForm.hora_chegada"
                  v-model="remessa.hora_chegada"
                ></as-time-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-container>

    <v-container fluid grid-list-lg v-show="!loading && $route.params.id">
      <v-layout row wrap>
        <v-flex sm6>
          <v-card>
            <v-app-bar color="primary" flat dark dense>
              <v-toolbar-title>Pedidos Entregues</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="tooglePesquisaPedidosFechados">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-app-bar>
            <v-expand-transition>
              <div
                v-show="exibirPesquisaPedidosFechados"
                class="pa-2"
                style="background-color: rgba(189, 189, 189, 0.3);"
              >
                <v-text-field
                  ref="pesquisaPedidosFechados"
                  label="Pesquisa"
                  v-model="pesquisaPedidosFechados"
                  prepend-inner-icon="search"
                  solo
                  clearable
                  single-line
                  hide-details
                  placeholder="Pesquisa"
                  color="primary"
                  @click:clear="tooglePesquisaPedidosFechados"
                ></v-text-field>
              </div>
            </v-expand-transition>
            <v-data-table
              :search="pesquisaPedidosFechados"
              :headers="headersPedidos"
              :items="pedidos"
              hide-default-footer
              :loading="loading"
              no-data-text="Sem registros"
              no-results-text="Sem registros"
              loading-text="Carregando dados..."
            >
              <template v-slot:item.acao="{ item }">
                <td class="text-xs-center">
                  <v-btn icon @click="incluirPedido(item)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </template>
              <template v-slot:item.valor="{ item }">
                <td>{{ item.valor | valorBR }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <v-flex sm6>
          <v-card>
            <v-app-bar color="primary" flat dark dense>
              <v-toolbar-title>Pedidos Remessa</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="tooglePesquisaPedidosRemessas">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-app-bar>

            <v-expand-transition>
              <div
                v-show="exibirPesquisaPedidosRemessas"
                class="pa-2"
                style="background-color: rgba(189, 189, 189, 0.3);"
              >
                <v-text-field
                  ref="pesquisaPedidosRemessas"
                  label="Pesquisa"
                  v-model="pesquisaPedidosRemessas"
                  prepend-inner-icon="search"
                  solo
                  clearable
                  single-line
                  hide-details
                  placeholder="Pesquisa"
                  color="primary"
                  @click:clear="tooglePesquisaPedidosRemessas"
                ></v-text-field>
              </div>
            </v-expand-transition>

            <v-data-table
              :search="pesquisaPedidosFechados"
              :headers="headersPedidos"
              :items="pedidos_remessa"
              hide-default-footer
              :loading="loading"
              no-data-text="Sem registros"
              no-results-text="Sem registros"
              loading-text="Carregando dados..."
            >
              <template v-slot:item.acao="{ item }">
                <td class="text-xs-center">
                  <v-btn icon @click="removerPedido(item)">
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </td>
              </template>
              <template v-slot:item.valor="{ item }">
                <td>{{ item.valor | valorBR }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ServiceRemessas from "@/services/remessas.js";
import moment from "moment";

export default {
  name: "RemessasForm",
  data() {
    return {
      hoje: moment().format("YYYY-MM-DD"),
      loading: false,
      salvando: false,
      user: {},
      exibirPesquisaPedidosFechados: false,
      exibirPesquisaPedidosRemessas: false,
      pesquisaPedidosFechados: "",
      pesquisaPedidosRemessas: "",
      form_valid: true,
      remessa: {
        numero: "",
        motorista: "",
        placa: "",
        data_saida: "",
        hora_saida: null,
        data_chegada: "",
        hora_chegada: null,
      },
      pedidos: [],
      pedidos_remessa: [],
      headersPedidos: [
        { text: "", value: "acao", sortable: false },
        { text: "Número", value: "id", width: "5%" },
        { text: "Data", value: "data", width: "15%" },
        { text: "Cliente", value: "cliente_nome", width: "40%" },
        { text: "Valor", value: "valor", width: "20%" },
      ],
      rulesForm: {
        motorista: [(value) => !!value || "Campo Obrigatório"],
        placa: [(value) => !!value || "Campo Obrigatório"],
        data_saida: [(value) => !!value || "Campo Obrigatório"],
        hora_saida: [(value) => !!value || "Campo Obrigatório"],
        data_chegada: [(value) => !!value || "Campo Obrigatório"],
        hora_chegada: [(value) => !!value || "Campo Obrigatório"],
      },
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.params.id) {
      this.editar(this.$route.params.id);
    }
  },
  methods: {
    tooglePesquisaPedidosFechados() {
      this.exibirPesquisaPedidosFechados = !this.exibirPesquisaPedidosFechados;
      if (this.exibirPesquisaPedidosFechados) {
        setTimeout(() => {
          this.$refs.pesquisaPedidosFechados.focus();
        }, 0);
      }
    },
    tooglePesquisaPedidosRemessas() {
      this.exibirPesquisaPedidosRemessas = !this.exibirPesquisaPedidosRemessas;
      if (this.exibirPesquisaPedidosRemessas) {
        setTimeout(() => {
          this.$refs.pesquisaPedidosRemessas.focus();
        }, 0);
      }
    },
    async editar(remessa_id) {
      try {
        this.loading = true;
        let response = await ServiceRemessas.editar(remessa_id);
        this.remessa = response.data.remessa;
        this.pedidos = response.data.pedidos_entregue;
        this.pedidos_remessa = response.data.pedidos_remessa;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    incluirPedido(remessa_selecionada) {
      let indice = this.pedidos.indexOf(remessa_selecionada);
      let remessa = this.clone(remessa_selecionada);
      this.pedidos.splice(indice, 1);
      this.pedidos_remessa.push(remessa);
    },
    removerPedido(remessa_selecionada) {
      let indice = this.pedidos_remessa.indexOf(remessa_selecionada);
      let remessa = this.clone(remessa_selecionada);
      this.pedidos_remessa.splice(indice, 1);
      this.pedidos.push(remessa);
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.salvando = true;
          let response = "";
          if (this.remessa.numero) {
            let post = {
              remessa: this.remessa,
              pedidos_remessa: this.pedidos_remessa,
            };
            response = await ServiceRemessas.atualizar(this.remessa.id, post);
            this.$router.push("/remessas");
          } else {
            response = await ServiceRemessas.salvar(this.remessa);
            this.$router.push({
              name: "remessas-editar",
              params: { id: response.data.remessa.id },
            });

            let response_novo = await ServiceRemessas.editar(response.data.remessa.id);
            this.remessa = response_novo.data.remessa;
            this.pedidos = response_novo.data.pedidos_entregue;
            this.pedidos_remessa = response_novo.data.pedidos_remessa;
          }
          this.$eventbus.notificar(response.data.msg);
        } catch (error) {
          console.log(error);
          this.$eventbus.erro(error.data.response.msg);
        } finally {
          this.salvando = false;
        }
      }
    },
  },
};
</script>
